import React from 'react'
import PricingCard from './PricingCard'
import "./PricingModal.css"

function PricingModal({priceDetails}) {
  return (
    <section className='pricing-model'>
        <p className='pricing-title-s text-left'>Pricing Model</p>
        <h4 className='pricing-title-p text-left'>Our <span>Engagement Models</span></h4>
        <p className='pricing-description text-left'>We provide flexible engagement models to ensure all our clients can choose as per their project needs.</p>
        <div className='pricing-cards'>
            {priceDetails.map((priceDetail,index)=> {
                return  <PricingCard key={index} {...priceDetail}/>
            })}
        </div>
    </section>
  )
}

export default PricingModal